import { DateTime } from 'luxon';

const getDesiredDate = (desiredTime: Date | string): string => {
  const desired = DateTime.fromJSDate(new Date(desiredTime));
  const today = DateTime.now();

  // Compare days, return empty string if the same day
  if (desired.hasSame(today, 'day')) {
    return '';
  }

  // Format as "DD/MM" otherwise
  return ` - ${desired.toFormat('dd/LL')}`;
};

export const getPickupTime = (time: any | string | null): string | undefined => {
  if (!time) return undefined;

  const formattedTime = DateTime.fromJSDate(new Date(time)).toFormat('HH:mm');
  return formattedTime + getDesiredDate(time);
};

export interface ThirdPartyMetadata {
  desiredTime: string;
  displayId: string;
  channelName: string;
  customer: {
    name: string;
    email?: string;
    phoneNumber?: string;
  };
}

/** We have this hack solution in backend currently to send the metadata through the comment in a JSON.stringify */
export const getThirdPartyMetadata = (orderComment: string): ThirdPartyMetadata | null => {
  let thirdPartyMetadata: ThirdPartyMetadata | null = null;

  try {
    const splitComment = orderComment?.split('\n');
    if (splitComment && splitComment.length > 0) {
      const maybeMetadata = JSON.parse(splitComment[0]);
      if (
        typeof maybeMetadata === 'object' &&
        maybeMetadata.desiredTime &&
        maybeMetadata.displayId &&
        maybeMetadata.channelName &&
        maybeMetadata.customer
      ) {
        thirdPartyMetadata = maybeMetadata as ThirdPartyMetadata;
      }
    }
  } catch (e) {
    // fallback: ignore if parsing fails
    thirdPartyMetadata = null;
  }

  return thirdPartyMetadata;
};

/** Also related to the hack solution from third party orders - extract the thirdPartyMetadata from the comment (if there is any) */
export const extractCleanComment = (comment?: string): string => {
  if (!comment) return '';

  const split = comment.split('\n');
  // If there is two rows, the first one is the metadata
  if (split.length > 1) {
    return split
      .slice(1)
      .join('\n')
      .trim();
  }

  // If there is only one row, we assume it is the comment
  return comment.trim();
};
